import { accreditations } from "@/mocks/home";
import PowerOutageEasterEgg from "./PowerOutageEasterEgg";

export default function Footer() {
  const hasAccreditations = accreditations && accreditations.length > 0;

  return (
    <footer className="bg-[#0A0A0A] text-white rounded-t-[40px] relative overflow-hidden">
      {/* Wasserzeichen */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center justify-center select-none hidden sm:flex"
        style={{ zIndex: 0 }}
      >
        <span
          className="font-heading font-black uppercase leading-none whitespace-nowrap"
          style={{
            fontFamily: '"Archivo Black", "Archivo", sans-serif',
            fontWeight: 900,
            letterSpacing: "-0.02em",
            fontSize: "clamp(64px, 22vw, 360px)",
            color: "rgba(255, 255, 255, 0.05)",
          }}
        >
          ZWEERING
        </span>
      </div>
      <div className="px-6 md:px-10 lg:px-14 pt-20 md:pt-28 pb-12 md:pb-16 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Footer Nav Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 " style={{}}>
            {/* Lösungen */}
            <div>
              <h3 className="font-heading font-bold text-[#4CAF50] text-sm uppercase tracking-wider mb-5">
                Lösungen
              </h3>
              <ul className="space-y-2.5">
                <li><a href="/photovoltaik" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Photovoltaik</a></li>
                <li><a href="/stromspeicher" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Stromspeicher</a></li>
                <li><a href="/wallbox" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Wallbox</a></li>
                <li><a href="/smart-home" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Smart Home</a></li>
                <li><a href="/notstrom" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Ersatzstrom</a></li>
                <li><a href="/e-check" className="group flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />E-Check</a></li>
              </ul>
            </div>

            {/* Für wen */}
            <div>
              <h3 className="font-heading font-bold text-[#4CAF50] text-sm uppercase tracking-wider mb-5">
                Für wen
              </h3>
              <ul className="space-y-2.5">
                <li><a href="/einfamilienhaus" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Einfamilienhaus</a></li>
                <li><a href="/mehrfamilienhaus" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Mehrfamilienhaus</a></li>
                <li><a href="/gewerbe" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Gewerbe</a></li>
                <li><a href="/landwirtschaft" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Landwirtschaft</a></li>
              </ul>
            </div>

            {/* Unternehmen */}
            <div>
              <h3 className="font-heading font-bold text-[#4CAF50] text-sm uppercase tracking-wider mb-5">
                Unternehmen
              </h3>
              <ul className="space-y-2.5">
                <li><a href="/ueber-uns" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Über uns</a></li>
                <li><a href="/karriere" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />Karriere</a></li>
                <li><a href="/g2-contracting" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />G2 Contracting</a></li>
                <li><a href="/g2-contracting/leistungen" className="flex items-center gap-2 text-foreground-400 hover:text-[#4CAF50] transition-colors text-sm"><span className="inline-block w-1 h-1 rounded-full bg-[#4CAF50]" />G2 Leistungen</a></li>
              </ul>
            </div>

            {/* Kontakt */}
            <div>
              <h3 className="font-heading font-bold text-[#4CAF50] text-sm uppercase tracking-wider mb-5">
                Kontakt
              </h3>
              <a href="tel:+492822791010" className="text-white hover:text-[#4CAF50] transition-colors text-base font-semibold block mb-3 whitespace-nowrap">
                02822 791010
              </a>
              <p className="text-foreground-400 text-sm leading-relaxed mb-5">
                An der Schleuse 10<br />
                46446 Emmerich am Rhein
              </p>
              <h4 className="font-heading font-bold text-white text-xs uppercase tracking-wider mb-2">
                Erreichbarkeit
              </h4>
              <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-foreground-400 text-sm pb-[5px]">
                <dt className="text-foreground-500">Mo–Do</dt>
                <dd>09:00–12:30 · 14:00–16:30</dd>
                <dt className="text-foreground-500">Fr</dt>
                <dd>09:00–14:00</dd>
                <dt className="text-foreground-500">Sa/So</dt>
                <dd>geschlossen</dd>
              </dl>
            </div>
          </div>


          {/* Accreditations — nur anzeigen wenn echte Zertifikate vorliegen */}
          {hasAccreditations && (
            <div className="mt-14 md:mt-20">
              <p className="text-foreground-400 text-xs mb-4">Unsere Zertifizierungen</p>
              <div className="flex flex-wrap gap-8 items-center">
                {accreditations.map((acc) => (
                  <img
                    key={acc.name}
                    src={acc.src}
                    alt={acc.name}
                    className="h-14 w-auto object-contain opacity-60 hover:opacity-100 transition-all duration-300"
                    style={{ filter: 'brightness(0) invert(1)' }}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Bottom Bar */}
          <div className={hasAccreditations ? "mt-14 md:mt-20 pt-7 pb-4 md:pb-6 border-t" : "pt-7 pb-4 md:pb-6 border-t"} style={{ borderTopColor: "rgba(76,175,80,0.15)" }}>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-400 text-xs text-center sm:text-left">
                © 2026 Zweering Elektrotechnik<br />
                &nbsp;<a href="/impressum" className="hover:text-[#4CAF50] transition-colors">Impressum</a> &middot; <a href="/datenschutz" className="hover:text-[#4CAF50] transition-colors">Datenschutz</a> &middot; <a href="/agb" className="hover:text-[#4CAF50] transition-colors">AGB</a>
              </p>
              <div className="flex items-center gap-5">
                <PowerOutageEasterEgg />
                <div className="flex items-center gap-4">
                  <a
                    href="https://www.instagram.com/zweering_elektro?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Zweering auf Instagram"
                    className="w-8 h-8 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-[#4CAF50] hover:border-[#4CAF50] transition-colors"
                  >
                    <i className="ri-instagram-fill w-4 h-4 flex items-center justify-center text-sm" />
                  </a>
                </div>
                <a
                  href="https://webdrei.studio"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground-600 hover:text-[#4CAF50] transition-colors text-[11px] whitespace-nowrap"
                >
                  Umsetzung: Webdrei Studio
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}